import { ANALYTICS_ENDPOINT, HEARTBEAT_ENDPOINT, HMAC_SECRET } from "./config";
import { hmacHex } from "./signer";

async function signedPost(url, totemId, jsonObj) {
    const body = JSON.stringify(jsonObj);
    const signature = await hmacHex(body, HMAC_SECRET);
    const res = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "X-Totem-Id": totemId,
            "X-Signature": signature,
        },
        body,
        keepalive: true,
    });
    if (!res.ok){
        const txt = await res.text().catch(() => "");
        console.error(`[analytics] HTTP ${res.status} on ${url}`, txt);
        throw new Error(`${url} -> HTTP ${res.status}`);
    }
    try {
        return await res.json();
    } catch {
        return {};
    }
}

export function postEvents(totemId, events) {
    return signedPost(ANALYTICS_ENDPOINT, totemId, { events });
}

export function postHeartbeat(totemId, base) {
    return signedPost(HEARTBEAT_ENDPOINT, totemId, {
        totem_id: base.totem_id,
        store_id: base.store_id,
        timestamp: new Date().toISOString(),
    });
}
